import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import SidebarContainer from '../SidebarContainer';
import DealerNav from '../../components/DealerNav';
import dealersActions from '../../redux/dealers/actions';
import employeesActions from '../../redux/employee/actions';
import revisionActions from '../../redux/dealerDataRevisions/actions';
import { Header, RevisionList } from '../../components/DealerDataRevisions';
import LoadingOverlay from '../../components/LoadingOverlay';
import { typeOptions, fieldOptions } from './options';
import './DealerDataRevisions.scss';

function DealerDataRevisions(props) {
  const { actions, revisions, dealer, match, users } = props;
  const { dealerId } = match.params;
  const [page, setPage] = useState(1);
  const [user, setUser] = useState(null);
  const [type, setType] = useState(null);
  const [field, setField] = useState(null);
  const [dateRange, setDateRange] = useState([
    moment()
      .subtract(7, 'd')
      .toDate(),
    moment().toDate(),
  ]);

  const fetchRevisions = useCallback(
    () =>
      actions.dealerDataRevisionsRequest({
        dealerId,
        options: {
          page,
          changedKey: field ? field.id : '',
          documentType: type ? type.id : '',
          userId: user ? user.id : '',
          startDate: moment(dateRange[0])
            .startOf('day')
            .toDate(),
          endDate: moment(dateRange[1])
            .endOf('day')
            .toDate(),
        },
      }),
    [actions, dealerId, dateRange, field, page, type, user],
  );

  useEffect(() => {
    actions.dealerRequest({ dealerId });
    actions.employeesRequest();
  }, [actions, dealerId]);

  useEffect(() => {
    fetchRevisions();
  }, [page, dateRange, user, type, field, fetchRevisions]);

  const userOptions = users.map(u => ({
    id: u.id,
    label: `${u.firstName} ${u.lastName} (${u.email})`,
  }));

  return (
    <SidebarContainer title={dealer.name} logo={dealer.logo}>
      <div className="dealers-table dealer-revisions">
        <DealerNav />
        <div className="dealer-editor-container">
          <LoadingOverlay active={props.fetching}>
            <Header
              user={user}
              type={type}
              field={field}
              setField={setField}
              setUser={setUser}
              setType={setType}
              dateRange={dateRange}
              setDateRange={setDateRange}
              userOptions={userOptions}
              typeOptions={typeOptions}
              fieldOptions={type ? fieldOptions[type.id] : []}
            />
            <RevisionList
              page={page}
              revisions={revisions}
              fetching={props.fetching}
              setPage={setPage}
            />
          </LoadingOverlay>
        </div>
      </div>
    </SidebarContainer>
  );
}

DealerDataRevisions.propTypes = {
  revisions: PropTypes.object,
  fetching: PropTypes.bool,
  actions: PropTypes.object,
  dealer: PropTypes.object,
  match: PropTypes.object,
  users: PropTypes.array,
};

const mapStateToProps = ({ employee, dealers, dealerDataRevisions }) => ({
  dealer: dealers.dealer,
  users: employee.employees,
  revisions: dealerDataRevisions.data,
  fetching: dealerDataRevisions.fetching,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    { ...revisionActions, ...dealersActions, ...employeesActions },
    dispatch,
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DealerDataRevisions),
);
